import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { RunningLate } = await import('./index');
    return {
        Component: RunningLate,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
